module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAYCAYAAAAVibZIAAAAAXNSR0IArs4c6QAAAVJJREFUOBFj3Lx3r/TvX3+PMDAyNgW6uyxgZGT8z0AhYPr78z////8MCv///Z+3fseeoxu37Tak0EwGJmQD/v//b/mH4f+Zddt3Tdly+LAgshwpbBRDoRqZgC7P/vnl+811O3YnAi1iJMVAkFpshkLM+M8gSm6Q4DYU6jxygoSgoVCzSQoSYg0lKUhIMxQtSNZv3z0VWyohy1BYkPz7/z8LWyqhxFD0IDkGyziMG7bt0frL8O8q1HZKqX/AVNpPuUuxOIMFixhZQsCC6ATzf4Ysfy+X85QbysjwmvE/Y0Wgh8t8WAlHiaH/mBgZZ7DycNT42Nq+R/YeWYbCverpeh7ZMBibNEOxeBVmEDJNrKE4vYpsGIxN0FCgV48DYzXbH4dXYQYh07gNJdKryIbB2NgMJcmrMIOQaRRDyfEqsmEwNgszO+PHvz8ZnzIyMdRSq4oGAAQTsUOnaQW5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./resources/images/a-arrow_2x.png
// module id = 952
// module chunks = 0